import createSettingsHOC from 'src/components/settings/create-settings-hoc';
import { useParams } from 'src/router/hooks';
import urls from 'src/sections/repository/urls';

import RepoAdminBreadcrumbs from '../components/breadcrumbs';

const Breadcrumbs = () => {
  const { repositoryOwner, repositorySlug } = useParams<{
    repositoryOwner: string;
    repositorySlug: string;
  }>();
  const settingsHref = urls.ui.admin(
    repositoryOwner || '',
    repositorySlug || ''
  );
  return <RepoAdminBreadcrumbs settingsHref={settingsHref} />;
};

// eslint-disable-next-line import/no-default-export
export default createSettingsHOC({
  breadcrumbs: Breadcrumbs,
});
